<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <h3 class="text-center" style="margin-bottom:20px;">提现</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <div v-if="showText" style="margin-bottom:10px;">您尚未设置提现方式. <a href="/buyer/withdraw" style="cursor: pointer;"> 现在添加.</a></div>
        <el-form-item label="" prop="withdraw_type_id" v-if="!showText">
          <el-select class="block height-50" v-model="form.withdraw_type_id" placeholder="选择提现方式">
            <el-option
              v-for="item in list"
              :key="item.id"
              :label="item.bank_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="amount" v-if="!showText">
          <YueDanIpt model="amount" type="number" :object="form" placeholder="提现金额" :focus="true"></YueDanIpt>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!showText">
        <el-button class="block" type="primary" @click="submit()" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../services/api.js'
import YueDanIpt from '../../../components/YueDanIpt'
let _ = require('lodash')


export default {
  name: 'AddAddress',
  props: ['max'],
  components: {
    YueDanIpt: YueDanIpt
  },
  data () {
    var checkAmount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('金额是必填项'));
      }
      if (value < 0) {
        return callback(new Error('提现金额不能小于0'));
      }
      if (value > this.max) {
        return callback(new Error('无足够可提现金额'));
      }
      callback();
    }
    return {
      dialogFormVisible: false,
      loading: false,
      errors: null,
      list: null,
      showText: false,
      isEmptyErrors: true,
      form: {
        withdraw_type_id: '',
        amount: ''
      },
      rules: {
        withdraw_type_id: [
          { required: true, message: '提现方式是必选项', trigger: 'change' }
        ],
        amount: [
          { validator: checkAmount, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init() {
      this.form = {
        withdraw_type_id: '',
        amount: ''
      }
      this.isEmptyErrors = true
    },
    async getWithdrawList () {
      let res = await api.getWithdrawList(this)
      if(res.body.result){
        this.list = res.body.result
        _.each(this.list, item => {
          if(item.type == 3){
            this.form.withdraw_type_id = item.id
            return false
          }
        }) 
        this.showText = false
      }else{
        this.showText = true 
      }
    },
    show () {
      this.dialogFormVisible = true
      this.getWithdrawList()
    },
    submit () {
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          let res = await api.post(this, {
            path: 'single.php',
            api: 'withdraw',
            data: this.form,
            loading: 'loading'
          })
          if (res.body.status == 'ok') {
            this.$emit('success')
            this.init()
            this.dialogFormVisible = false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/single_user_center/components/Withdraw.vue